<p>
  Rolls some dice and saves the result in a variable.
  <avr-autodoc-link anchor="roll"></avr-autodoc-link>
</p>

<div fxLayout="row" fxLayoutGap="4px" fxLayoutAlign="left center" class="auto-row">
  <mat-form-field fxFlex="1 3 auto">
    <input matInput
           placeholder="Name"
           (change)="changed.emit()"
           [(ngModel)]="effect.name"
           required
           matTooltip="The result of the roll will be saved to an automation variable with this name."
           class="text-monospace">
  </mat-form-field>
  <mat-form-field fxFlex="3 1 auto">
    <input matInput placeholder="Dice" (change)="changed.emit()" [(ngModel)]="effect.dice" required>
    <span matSuffix matTooltip="AnnotatedString - variables and functions allowed in braces">{{"{ }"}}</span>
  </mat-form-field>
</div>

<p class="auto-label">Additional Options</p>
<div fxLayout="row" fxLayoutGap="4px" fxLayoutAlign="left center" class="auto-row">
  <div fxFlex="1 4 auto" fxLayoutAlign="center center">
    <mat-checkbox [(ngModel)]="effect.hidden"
                  (change)="changed.emit()"
                  matTooltip="If checked, the roll won't display in the automation's Meta field or apply bonuses from the -d argument.">
      Hidden
    </mat-checkbox>
  </div>
  <div fxFlex="1 4 auto" fxLayoutAlign="center center">
    <mat-checkbox [(ngModel)]="effect.fixedValue"
                  (change)="changed.emit()"
                  matTooltip="If checked, the roll won't apply bonuses from the -d argument.">
      Fixed Value
    </mat-checkbox>
  </div>
  <mat-form-field fxFlex="4 1 auto">
    <input matInput
           placeholder="Display Name"
           (change)="changed.emit()"
           [(ngModel)]="effect.displayName"
           matTooltip="The name to display in the Meta field. If left blank, will use the saved name."
           class="text-monospace">
  </mat-form-field>
</div>

<div>
  <p class="auto-label">Spell Options</p>
  <div fxLayout="column" fxLayout.gt-xs="row" fxLayoutGap="4px" fxLayoutAlign="left center">
    <avr-higher-level fxFlex [parent]="effect" [spell]="spell" (changed)="changed.emit()" *ngIf="spell"></avr-higher-level>
    <mat-checkbox [(ngModel)]="effect.cantripScale" (change)="changed.emit()">
      Scales like Cantrip
    </mat-checkbox>
  </div>
</div>
